import { Routes } from '@angular/router';
import { authGuard } from './core/auth/auth.guard';

/**
 * Routes that exist only while developing.
 *
 * `angular.json` replaces this file with `dev-routes.prod.ts` for the production
 * configuration, so nothing named here is imported, compiled or bundled in a release —
 * which is the point: a style guide is a tool for whoever is building the app, not a
 * page a venue should be able to reach, and it carries enough CSS of its own to trip the
 * per-component style budget if it were ever compiled into a release.
 */
export const devRoutes: Routes = [
  {
    // The living style guide: every design token and shared component, rendered. Open it
    // before building a screen, and expect it to be what breaks the build when a token
    // is renamed or a component's API changes.
    path: 'design',
    canActivate: [authGuard],
    loadComponent: () => import('./features/design-system/design-system.component')
      .then(m => m.DesignSystemComponent),
  },
];
